import { SubscriptionContext } from "./subscriptionContextState";
import React, { useMemo } from "react";
import { useFitnessCenter } from "@/hooks/settings/useFitnessCenter";
import { useAuth } from "@/contexts/AuthContext";

export const SubscriptionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated, isAuthReady } = useAuth();
  // TanStack Query handles the fetch.
  // If it gets a 401, your interceptor refreshes the token and retries.
  const { data, isLoading } = useFitnessCenter(isAuthReady && isAuthenticated);

  const value = useMemo(() => {
    const sub = data?.subscription;
    const status = sub?.status || null;

    const isBlocked = status !== "active" && status !== "trial";

    const subscription = {
      status,
      billingCadence: sub?.billingCadence,
      provider: sub?.provider,
      nextBillingDate: sub?.nextBillingDate || null,
      expiredOn: sub?.expiredOn || null,
      subscriptionId: sub?.subscriptionId || null,
      tierQuantity: sub?.tierQuantity || 0,
      portalUrl: sub?.portalUrl || null,
      isSubscriptionActive: !isBlocked,
      isLoading,
      gymName: data?.name || "",
      email: data?.email || "",
      trialEndDate: sub?.trialEndDate || null,
      seenReferralModal: data?.uiFlags?.seenReferralModal ?? false,
    };
    return subscription;
  }, [data, isLoading]);

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};

